import React from 'react'

const Footer = () => {
  return (
    <footer class="footer">
        <div class="container">
        <p>&copy; 2024 Ankit Biswas | WebSpace</p>
        </div>
    </footer>
  )
}

export default Footer